export default "__VITE_ASSET__CZQeLHW7__"